/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Jednostka budżetu podgrupy liczonego na osobę: PORTION = tyle porcji na głowę, GRAM = tyle gramatury na głowę (liczbę porcji wyliczamy z gramatury porcji dania; mililitry liczą się jak gramy). Null czytamy jak PORTION.  To NIE jest tryb podgrupy — różnorodność (ile różnych dań) i ilość na osobę są niezależne, a jednostka dotyczy wyłącznie tej drugiej. 
 */

export const PerPersonUnitDto = {
    Portion: 'PORTION',
    Gram: 'GRAM',
} as const;

export type PerPersonUnitDto = typeof PerPersonUnitDto[keyof typeof PerPersonUnitDto];



